import { ReactNode } from "react";
import { Card } from "@components/theming";

export default function TicketGateCard({ children }: { children: ReactNode }) {
  return (
    <Card
      sharedClasses="mt-4 p-6"
      shopsiteClasses="bg-white border border-gray-200 rounded-xl"
      whitelabelClasses="max-sm:mb-6"
    >
      {children}
    </Card>
  );
}
